export type Region = "IN" | "EU" | "UK" | "US" | "AU" | "ROW";

export const REGION_LABELS: Record<Region, { name: string; flag: string }> = {
  IN: { name: "India", flag: "🇮🇳" },
  EU: { name: "European Union", flag: "🇪🇺" },
  UK: { name: "United Kingdom", flag: "🇬🇧" },
  US: { name: "United States", flag: "🇺🇸" },
  AU: { name: "Australia", flag: "🇦🇺" },
  ROW: { name: "Other regions", flag: "🌍" },
};

const EU_COUNTRY_CODES = new Set([
  "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT",
  "LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE",
]);

export function countryToRegion(cc?: string | null): Region {
  if (!cc) return "ROW";
  const c = cc.toUpperCase();
  if (c === "IN") return "IN";
  if (c === "GB" || c === "UK") return "UK";
  if (c === "US") return "US";
  if (c === "AU") return "AU";
  if (EU_COUNTRY_CODES.has(c)) return "EU";
  return "ROW";
}

const STORAGE_KEY = "gaonova-region";

export function detectInitialRegion(): Region {
  // 1. URL ?region=
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("region")?.toUpperCase();
    if (fromUrl && ["IN","EU","UK","US","AU","ROW"].includes(fromUrl)) {
      return fromUrl as Region;
    }
  } catch { /* ignore */ }

  // 2. localStorage
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && ["IN","EU","UK","US","AU","ROW"].includes(stored)) return stored as Region;
  } catch { /* ignore */ }

  // 3. Browser locale
  try {
    const locale =
      Intl.DateTimeFormat().resolvedOptions().locale ||
      navigator.language ||
      "en-IN";
    const region = locale.split("-")[1];
    if (region) return countryToRegion(region);
  } catch { /* ignore */ }

  return "IN";
}

export function persistRegion(region: Region) {
  try { localStorage.setItem(STORAGE_KEY, region); } catch { /* ignore */ }
}
